import { Icon } from './chunk-VH4ICUUK.js';
import { tv } from './chunk-7NOFBOMW.js';
import { cn } from './chunk-UYYBXMNI.js';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var radioGroupVariants = tv({
  base: "group grid gap-2"
});
var RadioGroup = forwardRef(
  ({ className, invalid, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      RadioGroupPrimitive.Root,
      {
        "aria-invalid": invalid,
        className: radioGroupVariants({ className }),
        ...props,
        ref
      }
    );
  }
);
var radioGroupItemVariants = tv({
  slots: {
    root: [
      "border-primary text-primary ring-offset-background group-aria-[invalid=true]:border-destructive hover:bg-accent peer aspect-square h-4 w-4 rounded-full border disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 group-aria-[invalid=true]:hover:bg-transparent",
      "focus-visible:ring-ring focus:ring-offset-2 focus-visible:outline-none focus-visible:ring-2"
    ],
    icon: "fill-primary group-aria-[invalid=true]:fill-destructive group-aria-[invalid=true]:text-destructive w-2.5, h-2.5"
  }
});
var RadioGroupItem = forwardRef(
  ({ className, classNames, ...props }, ref) => {
    const slots = radioGroupItemVariants();
    const rootClasses = cn(classNames?.root, className);
    const iconClasses = classNames?.icon;
    return /* @__PURE__ */ jsx(
      RadioGroupPrimitive.Item,
      {
        ref,
        className: slots.root({ class: rootClasses }),
        "aria-label": props.value,
        ...props,
        children: /* @__PURE__ */ jsx(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Icon, { name: "circle", className: slots.icon({ class: iconClasses }) }) })
      }
    );
  }
);
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
//# sourceMappingURL=chunk-434O4KNG.js.map
//# sourceMappingURL=chunk-434O4KNG.js.map